import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Text, IconTooltip} from '@forecast-it/design-system';

export function NoteRequiredInfo(): JSX.Element {
	return (
		<div>
			<Text size={'2'}>You need to add a note to create a time registration.</Text>
			<Text size={'2'} color={'medium'}>
				This is a company-wide setting configured by your admin.
			</Text>
		</div>
	);
}

export function NoteRequiredInfoIcon(): JSX.Element {
	return (
		<IconTooltip icon={'info'} color={'disabled'} iconSize={'s'}>
			<NoteRequiredInfo />
		</IconTooltip>
	);
}

type TextSize = '1' | '2'; // FIXME: import from design system or derive from Text.Size

export function NoteRequiredError({textSize}: {textSize?: TextSize}): JSX.Element {
	return (
		<Text color={'error'} size={textSize || '2'}>
			<FormattedMessage id="time_registration.note_required_error" />
		</Text>
	);
}
